export const SampleEditSessionUrl = {
  open: '/samples/edit-sessions',
  hasPendingDrafts: '/samples/edit-sessions/{sessionId}/has-pending-drafts',
  discard: '/samples/edit-sessions/{sessionId}',
  rows: '/samples/edit-sessions/{sessionId}/rows',
  validateRow: '/samples/edit-sessions/{sessionId}/validate-row',
  commit: '/samples/edit-sessions/{sessionId}/commit',
} as const;
